export default "__VITE_ASSET__nqIt4VzA__"